import React from "react";
import { Layouts } from "@website-builder/ui/b2c";
import { Sections } from "@website-builder/ui/b2c";
import { Blocks } from "@website-builder/ui/b2c";
import { PageNotFound } from "@website-builder/ui/shared/components";
import { storyblokTransformer } from "../../../components/Transformers";
import { addToDataLayer } from "@website-builder/utilities-index";

const BlockList = { ...Blocks, PageNotFound };

const GenericLayout = ({ story, basicConfig = {}, storyList = [] }) => {
	// page_course_slug is extracted from page_properties and passed along with all GA4 and some segment events
	addToDataLayer({
		page_course_slug: story?.content?.course_slug,
	});
	const { transformerParams } = basicConfig;

	story = storyblokTransformer(story, transformerParams);

	if (story) {
		const {
			page: {
				layout: { header, footer },
				context,
				sections,
			},
		} = story;

		const HeaderFooter = Layouts["HeaderFooter"];

		return (
			<HeaderFooter header={header} footer={footer} context={context}>
				{sections.map(({ type, blocks = [], props }, index) => {
					const Section = Sections[type];
					const { hashLink, pageSection } = props;
					return (
						<Section
							context={context}
							key={`${type}--${index}`}
							type={type}
							{...props}
						>
							{blocks.map(({ type, props }, index) => {
								if (BlockList[type]) {
									const Block = BlockList[type];
									return (
										<Block
											type={type}
											key={`${type}--${index}`}
											hashLink={hashLink}
											pageSection={pageSection}
											workshopId={context?.workshop_id}
											context={context}
											{...props}
										/>
									);
								} else {
									console.error(`BLOCK : ${type} NOT FOUND!`);
									return;
								}
							})}
						</Section>
					);
				})}
			</HeaderFooter>
		);
	} else {
		console.error("TRANSFORMER DID NOT RETURN A VALID STORY!");
		return null;
	}
};

export default GenericLayout;
